import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from './auth.service';


@Injectable()
export class AuthInterceptor implements HttpInterceptor
{
    /**
     * Constructor
     */
    constructor(private _authService: AuthService)
    {
    }
x
    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        // Clone the request object
        let newReq = req.clone();

        // Request
        //
        // If the access token didn't expire, add the Authorization header.
        // We won't add the Authorization header if the access token expired.
        // This will force the server to return a "401 Unauthorized" response
        // for the protected API routes which our response interceptor will
        // catch and delete the access token from the local storage while logging
        // the user out from the app.

        // Get the token from the AuthService
        const token = this._authService.obtenerTokenBearer();

        // Add API Key header to all requests
        let headers = req.headers.set('X-Pet24-API-Key', 'pet24-web-client-v2.1-secure-token-2025');

        // If the token exists, add the Authorization header
        if (token) {
            headers = headers.set('Authorization', 'Bearer ' + token);
        }

        // Extract userId from userSession and add X-User-Id header for Radar module
        const userSessionString = localStorage.getItem('userSession');
        if (userSessionString) {
            try {
                const userSession = JSON.parse(userSessionString);
                if (userSession?.id) {
                    headers = headers.set('X-User-Id', userSession.id.toString());
                }
            } catch (e) {
                // Silently fail if userSession is not valid JSON
            }
        }

        // Clone request with updated headers
        newReq = req.clone({ headers });

        // Response
        return next.handle(newReq).pipe(
            catchError((error) => {

                // Catch "401 Unauthorized" responses
                if ( error instanceof HttpErrorResponse && error.status === 401 )
                {
                    // Sign out
                    this._authService.signOut();

                    // Reload the app
                    location.reload();
                }

                return throwError(error);
            })
        );
    }
}
